// AUTHOR: NANDHAKUMAR
// VERSION: 0.0.1
// LAST EDIT: NANDHAKUMAR
// DATE: 17/09/2025
// DESCRIPTION: QR REPORT PAGE REDUCER
/* eslint-disable import/no-anonymous-default-export */
import { docodeHexResponse } from '../../_common/common.utils';
import QrReportActionTypes from './qr-report.types';
const INITIAL_STATE = {
	fetchQrReportResponse: null,
	fetchQrReportArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET QR REPORT DETAILS START *********************** */
		case QrReportActionTypes.FETCH_QR_REPORT_SUCCESS:
			return {
				...state,
				fetchQrReportResponse: action.payload,
				fetchQrReportArr: docodeHexResponse(action.payload, 'QRPaymentReportKey'),
			};

		case QrReportActionTypes.FETCH_QR_REPORT_FAILURE:
			return { ...state, fetchQrReportResponse: action.payload };

		case QrReportActionTypes.FETCH_QR_REPORT_RESPONSE_CHANGED:
			return {
				...state,
				fetchQrReportResponse: null,
			};
		/** ***************** GET QR REPORT DETAILS END *********************** */

		default:
			return state;
	}
};
